import React, { FC } from 'react'
import styled from 'styled-components'

import { breakpoints } from '@ads/front-core/constants/breakpoints'
import { lng, Trans } from '@ads/front-core/locales'
import { Icon1 } from './icons/Icon1'
import { Icon2 } from './icons/Icon2'
import { Icon3 } from './icons/Icon3'
import { DotsDesktop } from './DotsDesktop'
import { DotsMobile1, DotsMobile2 } from './DotsMobile'

export const How: FC = () => (
  <Wrapper>
    <Content>
      <HeaderText>
        <Trans
          i18nKey="lppartners:how.header"
          components={{
            bold: <TextBold />,
          }}
        />
      </HeaderText>
      <DotsDesktop />
      <Items>
        <Item>
          <Icon1 />
          <ItemHeader>{lng('lppartners:how.box1.header')}</ItemHeader>
          <ItemText>{lng('lppartners:how.box1.text')}</ItemText>
          <DotsMobile1 />
        </Item>
        <Item>
          <Icon2 />
          <ItemHeader>{lng('lppartners:how.box2.header')}</ItemHeader>
          <ItemText>{lng('lppartners:how.box2.text')}</ItemText>
          <DotsMobile2 />
        </Item>
        <Item>
          <Icon3 />
          <ItemHeader>{lng('lppartners:how.box3.header')}</ItemHeader>
          <ItemText>{lng('lppartners:how.box3.text')}</ItemText>
        </Item>
      </Items>
    </Content>
  </Wrapper>
)

const Wrapper = styled.div`
  background-color: #f3f4f6;
`

const Content = styled.div`
  position: relative;
  font-family: Poppins;
  max-width: 1348px;
  margin: 0 auto;
  color: #262a44;
  padding: 53px 58px;

  @media (max-width: ${breakpoints.MOBILE}) {
    padding: 53px 32px;
  }
`

const HeaderText = styled.p`
  font-size: 36px;
  font-weight: 200;
  margin-bottom: 48px;

  @media (max-width: ${breakpoints.MOBILE}) {
    font-size: 26px;
  }
`

const TextBold = styled.strong`
  font-width: 600;
`

const Items = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0 24px;

  @media (max-width: ${breakpoints.MOBILE}) {
    grid-template-columns: 1fr;
    gap: 60px;
  }
`

const Item = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  position: relative;

  > svg {
    background-color: #f3f4f6;
    outline: 6px solid #f3f4f6;
    z-index: 1;
  }
`

const ItemHeader = styled.p`
  font-size: 18px;
  font-weight: 600;
  margin-top: 24px;
`

const ItemText = styled.p`
  font-size: 18px;
  font-weight: 200;
`
